const MobTable = ({ packingDetails }) => {
  return (
    <table className="responsiveTable lg:hidden">
      <thead>
        <tr>
          <th>Product</th>
          <th>Size</th>
          {/* <th>Actual Size</th> */}
          <th>Thickness</th>
          <th>Titles / Box</th>
          <th>Coverage Area / Box</th>
        </tr>
      </thead>
      <tbody>
        {packingDetails.map((detail, index) => (
          <tr key={index}>
            <td data-label="Product">{detail.product_name}</td>
            <td data-label="Size">{detail.size}</td>
            {/* <td data-label="Actual Size">{detail.actual_size}</td> */}
            <td data-label="Thickness">{detail.thickness}</td>
            <td data-label="Tiles / Box">{detail.tiles_per_box} pcs.</td>
            <td data-label="Coverage Area / Box">{detail.area_per_box} sq ft</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default MobTable;
